import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useMockWebPhoenixHistorySetup = () => {
  // React Router v6 does not have useHistory
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window.__CNBC === 'undefined') {
      window.__CNBC = {};
    }

    const mockHistory = {
      location: {
        state: {},
      },
      replace: (url) => {
        // Replace true only works with relative paths otherwise concatenates the url to current path
        // in react-router-dom v6
        if (url.startsWith('http')) {
          const { origin } = window.location;
          const path = url.replace(origin, '');
          return navigate(path, { replace: true });
        }

        navigate(url, { replace: true });
      },
    };

    window.__CNBC.history = mockHistory;
  }, []);
};

export default useMockWebPhoenixHistorySetup;
